import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  CircularProgress,
  Button,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { useSelector } from "react-redux";
import { investorApi } from "../api/api";
import AddBankDetails from "../components/Pages/BankDetalis/AddBankDetails";
import { useNavigate } from "react-router-dom";
import Loader from "../components/common/Loader";
import GradientButton from "../components/common/GradiantButton";

const BankDetails = () => {
  const userId = useSelector((state) => state.user.userId);
  const [bankData, setBankData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchBankDetails = async () => {
      try {
        const response = await investorApi.getBankDetails(userId);
        if (response.status === 200 && response.data) {
          setBankData(response.data);
        } else {
          setBankData(null);
        }
      } catch (error) {
        console.error("Error fetching bank details:", error);
        setBankData(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBankDetails();
  }, [userId]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 5,minHeight:"80vh" }}>
      {isLoading ? (
        <Loader/>
      ) : (
        <>
          {!bankData ? (
            <AddBankDetails />
          ) : (
            <Paper
              elevation={4}
              sx={{
                p: 4,
                borderRadius: 4,
                background: "#f8fbff",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              }}
            >
              <Typography
                variant="h5"
                fontWeight="bold"
                color="primary"
                textAlign="center"
                gutterBottom
              >
                Bank Details
              </Typography>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                {[
                  {
                    label: "Account Holder Name",
                    value: bankData.AccountHolderName,
                  },
                  { label: "Account Number", value: bankData.AccountNumber },
                  {label:'Bank Name',value: bankData.BankName},
                  { label: "Branch", value: bankData.Branch },
                  { label: "IFSC Code", value: bankData.IFSCCode },

                ].map((item, index) => (
                  <Card
                    key={index}
                    elevation={2}
                    sx={{
                      borderRadius: 3,
                      background: "#fff",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle2"
                        color="text.secondary"
                        sx={{ fontSize: 13 }}
                        gutterBottom
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        color="text.primary"
                        sx={{ mt: 0.5 }}
                      >
                        {item.value || "--"}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
              <GradientButton text="Edit Bank Details" 
              onClick={() =>
                  navigate("/EditBankDetails", { state: bankData })
                }
                width="100%"
                style={{marginTop:5}}/>
                
            </Paper>
          )}
        </>
      )}
    </Container>
  );
};

export default BankDetails;
